import { inject, Injectable } from '@angular/core';
import { AppSettings } from '../app.settings';
import { HttpClient } from '@angular/common/http';
import { CustomResponse } from '../interfaces/custom-response.model';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root'
})
export class ChargeService {

  private apiEndpoint: string = AppSettings.settings.apiServer.backend;
  http = inject(HttpClient);

  constructor() { }

  getDashboardChargeList(page: number = 0) : Observable<CustomResponse>
  {
    let url = `${this.apiEndpoint}/dashboard/chargelist`

    if (page > 0)
    {
      url += "?page=" + page;
    }

    return this.http.get<CustomResponse>(url);
  }

  storeCharge(charge: any): Observable<CustomResponse>
  {
    let url = `${this.apiEndpoint}/charge/store`

    return this.http.post<CustomResponse>(url, charge);
  }


}
